import React, {Component} from 'react'
import FJResources from "../view/FJResources";
import FJResourcesMediaContainer from "./FJResourcesMediaContainer";
import FJResourcesTextContainer from "./FJResourcesTextContainer";
import FJResourcesElementContainer from "./FJResourcesElementContainer";
import FJElementAnimationContainer from "./FJElementAnimationContainer";
import FJResourcesOverLayContainer from "./FJResourcesOverLayContainer";
import FJFilterContainer from "./FJFilterContainer";
import FJViewConstant from "../../../constant/FJViewConstant";
import {connect} from 'react-redux'
import FJResourcesTransitionContainer from "./FJResourcesTransitionContainer";
import FJPhotoAnimationContainer from "./FJPhotoAnimationContainer";
import FJResourceWatermarkContainer from "./FJResourceWatermarkContainer";
import FJStockVideoContainer from "./FJStockVideoContainer";
import FJAdjustContainer from "./FJAdjustContainer";
import $ from "jquery";
import key from "keymaster";
import FJCanvasStore from "../../../store/FJCanvasStore";
import FJTimelineStore from "fj-timeline";
import FJConfig from "../../../config/FJConfig";
import {FJMediaAction, FJResourceAction, FJTimeLineAction} from "../../../redux/action/FJRoot.action";
import FJMedia from "../../../store/FJMedia";
import FJLazy from "../../../common/component/FJLazy";
import FJResourcesMoreContainer from "./FJResourcesMoreContainer";
import FJResourceExpand from "../view/FJResourceExpand";

class FJResourcesContainer extends Component {

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return !this.props || nextProps.showType !== this.props.showType || nextProps.isResourceExpand !== this.props.isResourceExpand;
  }

  /**
   * @description 拖动资源库文件
   * @param e
   * @param data
   * @param callback
   * @param getDragNodeInTimeLine
   * @param options
   * @param options.height
   * @private
   */
  _onMediaDrag = (e, data, callback, getDragNodeInTimeLine, options) => {
    let { eventType } = data;

    let point = {
      x: e.clientX,
      y: e.clientY,
    };

    let isInAddArea = point.y >= document.body.clientHeight - $(document.getElementById('timeline-container')).height();
    this._dragInfo = data;
    this._dragCallback = callback;

    switch (eventType) {
      case 'start':
        key.setScope('');
        break;
      case 'change':
        if (isInAddArea) {
          if (this._isDragToTimeline) {
            this._renderDragToTimeline('change', point, getDragNodeInTimeLine, options);
            return
          }
          this._renderDragToTimeline('start', point, getDragNodeInTimeLine, options);
          this._isDragToTimeline = true;
        } else {
          if (this._isDragToTimeline) {
            callback('delete');
            // 特殊处理：拖动资源到时间轴然后立刻离开
            FJCanvasStore.executeSync(FJCanvasStore.command.MOVE_OUT_TIMELINE_SPECIAL_TREATMENT);
            // 删除添加到时间轴的资源
            this.props.deleteDragToTimeline && this.props.deleteDragToTimeline();
          }
          callback('continue');
          this._removeContentCloneNode();
          this._isDragToTimeline = false;
        }
        break;
      case 'end':
        key.setScope('default');
        if (isInAddArea) {
          this._renderDragToTimeline('end', point, getDragNodeInTimeLine, options);
          this._removeContentCloneNode();
        }
        this._isDragToTimeline = false;
        this.props.setDraggingState && this.props.setDraggingState(false);
        break;
    }
  };

  /**
   * @description 渲染拖动元素到时间轴区域的dom样式
   * @param type
   * @param point
   * @param getDragNodeInTimeLine
   * @param options
   * @param options.height
   * @param options.zIndex
   * @param options.dragToTimelineData
   * @private
   */
  _renderDragToTimeline = (type, point, getDragNodeInTimeLine, options) => {

    if (!type || !point) {
      return;
    }

    let unitConversion = FJTimelineStore.getUnitConversion();
    let fixedDuration = FJConfig.fixedDuration;

    let duration = this._dragInfo.duration || fixedDuration;
    let selfRectHeight = options && options.height || 44;
    let selfRect = {
      width: unitConversion * duration,
      height: selfRectHeight,
    };

    if (type === 'start') {
      this._dragCallback('delete');
      this._cloneNode = this._cloneNode || document.createElement('div');
      this._cloneNode.appendChild(getDragNodeInTimeLine(selfRect, this._dragInfo));
      document.body.appendChild(this._cloneNode);
      this.props.setDraggingState && this.props.setDraggingState(true);
    }

    $(this._cloneNode).css({
      visibility: 'visible',
      position: 'fixed',
      bottom: 'inherit',
      left: point.x,
      top: point.y - selfRect.height / 2,
      width: selfRect.width,
      height: selfRect.height,
      zIndex: FJConfig.mediaDragZindex,
      cursor: 'move',
      opacity: .8
    });

    let info = {
      dragMode: 2,
      eventType: type,
      cursorPoint: point,
      selfRect: {
        left: point.x,
        top: point.y - selfRect.height / 2,
        ...selfRect
      }
    };

    let {id, type: resourceType, fromType, options: dragInfoOptions} = this._dragInfo;
    this.props.dragToTimeline(resourceType, fromType, id, {...info, ...dragInfoOptions, duration});
  };

  /**
   * @description 删除添加的随着鼠标拖动的div
   */
  _removeContentCloneNode = () => {
    if (this._cloneNode && this._cloneNode.parentNode) {
      this._cloneNode.parentNode.removeChild(this._cloneNode);
      this._cloneNode = null;
    }
  };

  render() {
    let {height, showType, isResourceExpand} = this.props;
    let {toggleResourceExpand} = this.props;
    let {
      RESOURCES_MEDIA,
      RESOURCES_TEXT,
      RESOURCES_BACKGROUND,
      RESOURCES_ELEMENT,
      RESOURCES_OVERLAY,
      RESOURCES_TRANSITION,
      RESOURCES_ANIMATION_INTRO,
      RESOURCES_ANIMATION_OUTRO,
			RESOURCES_PHOTO_TRANSITION,
      RESOURCES_FILTER,
      RESOURCES_ADJUST,
			RESOURCES_WATER_MARK,
      RESOURCES_MORE
    } = FJViewConstant;

    return (
      <FJResources isExpand={isResourceExpand}>
        <FJLazy shown={showType === RESOURCES_MEDIA} render={(shown) => <FJResourcesMediaContainer onMediaDrag={this._onMediaDrag} isShow={shown} height={height} />} />
        <FJLazy shown={showType === RESOURCES_TEXT} render={(shown) => <FJResourcesTextContainer onMediaDrag={this._onMediaDrag} isShow={shown} />} />
        <FJLazy shown={showType === RESOURCES_ANIMATION_INTRO || showType === RESOURCES_ANIMATION_OUTRO} render={(shown) => <FJElementAnimationContainer isShow={shown} />} />
        <FJLazy shown={showType === RESOURCES_TRANSITION} render={(shown) => <FJResourcesTransitionContainer onMediaDrag={this._onMediaDrag} isShow={shown} />} />
        <FJLazy shown={showType === RESOURCES_PHOTO_TRANSITION} render={(shown) => <FJPhotoAnimationContainer isShow={shown} />} />
        <FJLazy shown={showType === RESOURCES_WATER_MARK} render={(shown) => <FJResourceWatermarkContainer isShow={shown} />} />
        <FJLazy shown={showType === RESOURCES_FILTER} render={(shown) => <FJFilterContainer isShow={shown} />} />
        <FJLazy shown={showType === RESOURCES_ADJUST} render={(shown) => <FJAdjustContainer isShow={shown} />} />
        <FJLazy shown={showType === RESOURCES_OVERLAY} render={(shown) => <FJResourcesOverLayContainer onMediaDrag={this._onMediaDrag} isShow={shown} />} />
        <FJLazy shown={showType === RESOURCES_MORE} render={(shown) => <FJResourcesMoreContainer isShow={shown} />} />
        <FJLazy shown={showType === RESOURCES_ELEMENT} render={(shown) => <FJResourcesElementContainer onMediaDrag={this._onMediaDrag} isShow={shown} />} />
        <FJLazy shown={showType === RESOURCES_BACKGROUND} render={(shown) => <FJStockVideoContainer onMediaDrag={this._onMediaDrag} isShow={shown} />} />
        <FJResourceExpand isExpand={isResourceExpand} onClick={toggleResourceExpand}/>
      </FJResources>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    showType: state.resource.showType,
    isResourceExpand: state.resource.isResourceExpand,
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    dragToTimeline: function (type, fromType, value, options) {
      dispatch(FJMediaAction.dragToTimelineAction(type, fromType || FJMedia.MediaFromType().LOCAL, value, options));
    },
    deleteDragToTimeline: function (id) {
      dispatch(FJMediaAction.deleteDragToTimelineAction(id));
    },
		setDraggingState: function (boolean) {
			dispatch(FJTimeLineAction.setDraggingStateAction(boolean));
		},
    toggleResourceExpand: function () {
      dispatch(FJResourceAction.toggleResourceExpandAction());
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FJResourcesContainer);
